'use strict';

// TODO lyleshearer 11/22/2013 - this module needs to be split into pure window.onerror handling and
// modular, lazy-loaded methods
var ajax = require('./xhr').instance;
var root = require('./root').window;
var ErrorModel = require('./error-model');
var domainRegex = /https?:\/\/[a-z]+\.hudl\.com/i;
var httpRegex = /https?:\/\//i;
var xpopupRegex = /xpopup\.js/i;
var urlRegex = /(https?|file):/i
var hashCodeToThrottleMap = {};
var externalHandlers = [];
var logToConsole = false;

// binds a callback to a static event trigger (like window.onerror)
// but ensures that whatever callback was previously
// bound is still invoked
var listenTo = function(ptr, listener) {
  var oldPtr = ptr;
  return function() {
    if(oldPtr) oldPtr.apply(null, arguments);
    listener.apply(null, arguments);
  }
};

var errorEventHandler = function(errorMsg, url, lineNumber, column, errorObj) {
  url = urlRegex.test(url) ? url : '';
  if (!shouldIgnore(url, lineNumber)) {
    var model = new ErrorModel(errorMsg, url, lineNumber, column, errorObj);
    throttledTransmitError(model.signature, model.toLog());

    externalHandlers.forEach(function(callback) {
      callback.apply(model, [errorMsg, url, lineNumber, column, errorObj]);
    });
  }
  return false;
};

// Based on _.throttle
// Returns a function, that, when invoked, will trigger at an exponentially-decreasing amount.
// Used to prevent floods of errors originating from bad JS code, Browser extensions, etc.
var expBackoff = function (func) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  var count = 1;
  var later = function () {
    previous = new Date();
    timeout = null;
    result = func.apply(context, args);
  };
  return function () {
    var now = new Date();
    if (!previous) previous = now;
    var wait = Math.random() * (Math.pow(2, Math.min(5, count++)) - 1); // random number between 0 and (2^count - 1) (where count is capped at 5)
    var remaining = (1000 * Math.abs(wait)) - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0) {
      clearTimeout(timeout);
      timeout = null;
      previous = now;
      result = func.apply(context, args);
    } else if (!timeout) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
};

var throttledTransmitError = function (signature, finalError) {
  var hashedFunc;
  if (hashCodeToThrottleMap[signature]) {
    hashedFunc = hashCodeToThrottleMap[signature];
  } else {
    hashedFunc = expBackoff(_transmitError);
    hashCodeToThrottleMap[signature] = hashedFunc;
  }

  if(logToConsole) {
    console.log(signature, finalError);
  }

  // transmits the JS error with an exponential-backoff algorithm, specific to this unique error, to prevent spamming our servers
  hashedFunc(finalError);
};

// don't call this directly, instead call throttledTransmitError
var _transmitError = function (finalError) {
  // xpopup.js has a nasty way of making it through - so ignore it if it's contained anywhere in the message
  if (xpopupRegex.test(finalError)) {
    return;
  }

  var xmlRequest;
  try {
    xmlRequest = new XMLHttpRequest();
  } catch (ex) {
    try {
      /* global ActiveXObject */
      xmlRequest = new ActiveXObject('Microsoft.XMLHTTP');
    } catch (e) { }
  }
  if (xmlRequest) {
    var requestId = '';
    try {
      requestId = document.head.getAttribute('data-request-id');
    } catch (ex) { }
    xmlRequest.open('POST', '/Services/WebErrorReporter.ashx', true);
    xmlRequest.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xmlRequest.send('requestId=' + requestId + '&error=' + escape(finalError));
  }
};

function shouldIgnore(file, line) {
  // we don't care about files from third-party javascript frameworks
  if (file && httpRegex.test(file) && !domainRegex.test(file)) {
    return true;
  }

  // ignore Chrome extension errors
  if (file && ((file.indexOf('chrome') === 0) || (file === 'runtime'))) {
    return true;
  }

  // we filter out errors with lineNumber=0 (or undefined) because there's little/nothing we can do about them
  if (line === 0) {
    return true;
  }

  return false;
}

// lock here because we only want one instance of the
// error reporter to get notified when an error occurs.
// there can be multiple instances of the error-reporter
// loaded on a single page due to the many different
// package managers we use (combres, requirejs, and webpack).
// TODO: once "webpack all the things" (WAT) is done, we'll be able
// to remove this lock.
if(!root.__hudl_base_errorReporter_lock) {
  root.__hudl_base_errorReporter_lock = true;
  root.onerror = listenTo(root.onerror, errorEventHandler);
}

module.exports = {
  enableConsoleLogging: function() {
    logToConsole = true;
  },

  disableConsoleLogging: function() {
    logToConsole = false;
  },

  sendLog: function(message) {
    return ajax.post('/Logging/LogMessage', { message: message });
  },

  listenToError: function(callback) {
    externalHandlers.push(callback);
  },

  sendError: function(error, eventName, eventHandler) {
    var isFromSilverlight = error.get_message && error.get_statusCode;
    var isJavaScriptError = error.constructor === Error;

    var errorModel;

    // build up a decorator to add more meta data to our
    // error log
    var decorator = {};

    if(isFromSilverlight || isJavaScriptError) {
      if (shouldIgnore(error.fileName, error.lineNumber)) {
        return;
      }

      errorModel = new ErrorModel(error);
    } else {
      // we've got almost nothing to go on here
      errorModel = new ErrorModel(
        // message
        error,
        // url
        undefined,
        // line
        undefined,
        // column,
        undefined,
        // error object
        new Error(error)
      );
    }

    if (eventName) {
      decorator['Event'] = eventName;
    }
    if (eventHandler) {
      decorator['EventHandler'] = eventHandler.toString();
    }

    return throttledTransmitError(errorModel.signature, errorModel.toLog(decorator));
  }
};
